import { DocumentData, QueryDocumentSnapshot } from "@firebase/firestore";
import { FirebaseConverter } from "../../../firebase/firebaseConverter";
import { ClimbingEvent } from "../../../models/ClimbingEvent";
export class EventFirebaseConverter extends FirebaseConverter<ClimbingEvent>{

    private convertDate(date: number | string): number {
        return typeof date == "string" ? date = Date.parse(date) : date;
    }
    fromFirestore(snapshot: QueryDocumentSnapshot<DocumentData>): ClimbingEvent {
        let event = snapshot.data() as ClimbingEvent
        event.startDate = this.convertDate(event.startDate)
        event.endDate = this.convertDate(event.endDate)
        if (event.routesToNrOfClimbes) {
            event.routesToNrOfClimbes = new Map<number, number>(Object.entries(event.routesToNrOfClimbes).map((k, v) => [Number(k[0]), k[1]]))
        }
        if (event.groups) {
            event.groups = event.groups.map(group => { return { ...group, startDate: this.convertDate(group.startDate), endDate: this.convertDate(group.endDate) } })
        }
        return event;
    }

}